import PlaceholderImage from "../../../assets/placeholder.jpg";
import DeleteIcon from "../../../../src/assets/delete-icon.png";
// import { PlusOutlined } from '@ant-design/icons';
import { Empty, message, Modal } from "antd";
import { useEffect, useState } from "react";
import {
  DeleteServiceProviderGallery,
  GetServiceProviderGallery,
} from "../../../utils/api";
import { useParams } from "react-router-dom";
import Loader from "../../../components/shared/Loader";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// import ImageUploader from "../../shared/ImageUploader";
import { imgPath } from "../../../utils/axiosInstance";
import { CloseCircleFilled } from "@ant-design/icons";

const Gallery = ({ startDate, endDate }) => {
  const { id } = useParams();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState({ visible: false, data: null });

  // Uploader States
  // const [openUpload, setOpenUpload] = useState(false);
  // const [file, setFile] = useState(null);
  // const [cropper, setCropper] = useState(null);
  // const [uploadProgress, setUploadProgress] = useState(0);
  // const [loadingCrop, setLoadingCrop] = useState(false);
  // const [uploadComplete, setUploadComplete] = useState(false);
  // const fileInputRef = useRef(null);

  const getGallery = async (params) => {
    if (id) {
      try {
        setLoading(true);
        const res = await GetServiceProviderGallery(id, params);
        if (res?.isSuccess) {
          setImages(res?.items);
        } else {
          message.error("Error while fetching details, Please try again");
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    } else {
      message.error("Error while fetching details, Please try again");
    }
  };

  const handleDeleteImage = (img) => {
    setModalData({ visible: true, data: img });
  };

  const handleDeleteOk = async () => {
    setLoading(true);
    if (id) {
      try {
        const res = await DeleteServiceProviderGallery({
          id: modalData.data?.id,
        });
        if (res?.message === "Success") {
          setModalData({ visible: false, data: null });
          message.success(
            modalData?.data?.image.includes("mp4")
              ? "Video removed successfully"
              : "Image removed successfully"
          );
          await getGallery();
        } else {
          message.error("Error while Deleting, Please try again");
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      message.error("Error while fetching details, Please try again");
    }
  };

  const handleModalCancel = () => {
    setModalData({ visible: false, data: null });
  };

  useEffect(() => {
    let params = `filter=custom&startDate=${
      startDate === null ? "" : startDate
    }&endDate=${endDate === null ? "" : endDate}`;
    getGallery(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  // useEffect(() => {
  //     if (uploadComplete) {
  //         const timeout = setTimeout(() => {
  //             setUploadComplete(false);
  //             setCropper(null);
  //         }, 2000);
  //         return () => clearTimeout(timeout);
  //     }
  // }, [uploadComplete]);

  if (loading) {
    return <Loader height="h-16" margin="my-16" />;
  }
  // const VideoField = (props) => {
  //     const record = useRecordContext(props);
  //     return <video src={`${record.video}`} controls width="320" height="240"></video>;
  //   }

  const isVideo = (data) => {
    let format = data.split(".");
    // eslint-disable-next-line eqeqeq
    if (format[1] == "mp4") {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="w-full px-4 py-3">
        {/* <div className="flex justify-between">
                    <h2 className="text-lg font-semibold">Uploads</h2>
                    <div>
                        <PlusOutlined onClick={() => setOpenUpload(true)} />
                        <ImageUploader
                            openUpload={openUpload}
                            file={file}
                            setFile={setFile}
                            cropper={cropper}
                            setCropper={setCropper}
                            uploadProgress={uploadProgress}
                            setUploadProgress={setUploadProgress}
                            loadingCrop={loadingCrop}
                            setLoadingCrop={setLoadingCrop}
                            message={message}
                            setUploadComplete={setUploadComplete}
                            closeUploadModal={closeUploadModal}
                            fileInputRef={fileInputRef}
                        />
                    </div>
                </div> */}

        <div className="w-full flex justify-center py-4">
          <div className="grid grid-flow-row grid-cols-4 gap-8 w-11/12 xyxz">
            {images &&
              images?.length > 0 &&
              images.map((image, index) => {
                return (
                  <div
                    key={index}
                    className="relative box-shadow w-full h-52 rounded-lg"
                  >
                    <span>{isVideo(image?.image)}</span>
                    {isVideo(image?.image) ? (
                      <div>
                        <video
                          controls
                          width="100%"
                          key={index}
                          className="object-contain h-52 rounded-lg"
                        >
                          <source
                            src={`${imgPath}${image?.image}`}
                            type="video/mp4"
                          />
                          Sorry, your browser doesn't support embedded videos.
                        </video>
                      </div>
                    ) : (
                      <LazyLoadImage
                        key={index}
                        src={`${imgPath}${image?.image}`}
                        alt={image?.image}
                        placeholderSrc={PlaceholderImage}
                        effect="blur"
                        width="100%"
                        className="object-cover h-52 rounded-lg"
                      />
                    )}
                    <div className="absolute -top-4 right-3 bg-white rounded-full p-1 box-shadow">
                      <img
                        className="w-5 h-5 cursor-pointer"
                        src={DeleteIcon}
                        alt="delete-icon"
                        onClick={() => handleDeleteImage(image)}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        {images && images?.length === 0 && (
          <div className="w-full text-center my-16 font-medium text-xl">
            <Empty />
          </div>
        )}

        <Modal
          centered
          title={"Confirm Delete Image/video"}
          open={modalData.visible}
          onOk={handleDeleteOk}
          onCancel={handleModalCancel}
        >
          Are you sure you want to delete this image/video ?
        </Modal>
      </div>
    </>
  );
};

export default Gallery;
